
  import { defineComponent, PropType } from 'vue';

  import ModalComponent from '@/components/modals/ModalComponent.vue';

  import { TUploadingStatus } from './types';
  import UploadingStatus from './UploadingStatus.vue';

  export default defineComponent({
    name: 'UploadingPopupStatus',
    components: {
      UploadingStatus,
      ModalComponent,
    },
    props: {
      info: {
        type: Object as PropType<TUploadingStatus | null>,
        required: true,
      },
    },
    data(): {
      isShowPopup: boolean;
    } {
      return {
        isShowPopup: false,
      };
    },
    methods: {
      closePopup() {
        this.isShowPopup = false;
      },
      showPopup() {
        this.isShowPopup = true;
      },
    },
    watch: {
      info(value: TUploadingStatus) {
        if (!value) return;
        this.showPopup();
      },
    },
  });
